import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { GetAccountUserListParameterType } from '../types/options';
import { GetAccountUserListUsecaseImpl } from '../usecases/GetAccountUserListUsecase';
import { AccountUserListRepository } from '../repositories/AccountUserListRepository';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { AccountUserListResponseType } from '../types/accountUser';
import { ACCOUNT_USER_LIST_QUERY_KEYS } from './queryKeys';

export const useAccountUserListQuery = <SelectResultType = AccountUserListResponseType, Error = unknown>(
  listOptions: GetAccountUserListParameterType,
  options: QueryOptions<AccountUserListResponseType, Error, SelectResultType>,
): UseQueryResult<SelectResultType, unknown> => {
  const getAccountUserListUsecase = new GetAccountUserListUsecaseImpl(AccountUserListRepository);
  return useQuery<AccountUserListResponseType, Error, SelectResultType>(
    [...ACCOUNT_USER_LIST_QUERY_KEYS.LIST, listOptions],
    () => getAccountUserListUsecase.invoke(listOptions),
    { ...options },
  );
};
